<!--
  ctrLstCho.vue ( 대표모바일에서 들어온 경우 피보험자 서명 건 선택 화면 )
 -->
<template>
  <div id="wrap" class="wrap_layout">
    <Header :rtrnAnimInsYn="state.rtrnAnimInsYn" type="type_confirm" />
    <div class="container">
      <div class="contents">
        <!--Contents Area [s]-->
        <div class="section">
          <!-- 2021-08-02 : 수정 -->
          <p class="txt">
            언제나 메리츠화재를 사랑해 주셔서 감사드립니다.<br />해당 안내는
            <strong class="point">{{ state.yyyymmdd }}</strong> 요청하신
            안내입니다.
          </p>
          <!-- // 2021-08-02 : 수정 -->
          <p class="tit">진행단계</p>
          <ActiveAnimation root="ul" class="process_step">
            <li>
              <span class="tit_step">Step01</span>
              <p>계약 선택</p>
            </li>
            <li>
              <span class="tit_step">Step02</span>
              <p>계약기본사항 확인</p>
            </li>
            <li>
              <span class="tit_step">Step03</span>
              <p>대면설명여부 확인</p>
            </li>
            <li>
              <span class="tit_step">Step04</span>
              <p>전자서명</p>
            </li>
            <li>
              <span class="tit_step">Step05</span>
              <p>서명입력 및 주요사항확인</p>
            </li>
            <li>
              <span class="tit_step">Step06</span>
              <p>지문인증</p>
            </li>
            <li>
              <span class="tit_step">Step07</span>
              <p>완전판매모니터링</p>
            </li>
          </ActiveAnimation>
          <!-- 2021-08-02 : 추가 -->
          <p class="tit_tbl">대상계약 선택</p>
          <p class="txt">
            ※ 금일 알림톡을 수신한 계약이 보여집니다.<br />서명은 알림톡을
            <strong class="point">수신한 당일(24시)까지만 가능</strong>합니다.
          </p>
          <button type="button" class="btn_cont btn_round fr" @click="refresh">
            <span>대상계약 재조회</span>
          </button>
          <ul class="check_product_list mgt50">
            <li v-for="(vo, index) in state.ctrBasInfCoVoLst" :key="vo.prctrNo">
              <div class="tit_check">
                <span class="check_box">
                  <input
                    type="checkbox"
                    :id="'check' + index"
                    v-model="vo.checkStatus"
                    @change="setAgrChk(index)"
                  />
                  <label :for="'check' + index">{{ vo.untPdNm }}</label>
                </span>
              </div>
              <ul class="info_list">
                <li>
                  <strong class="tit_area">가계약번호</strong>
                  <p class="txt_area">{{ vo.prctrNo }}</p>
                </li>
                <li>
                  <strong class="tit_area">계약자</strong>
                  <p class="txt_area">{{ vo.polhdNm }}</p>
                </li>
                <li>
                  <strong class="tit_area">보험료</strong>
                  <p class="txt_area">{{ numberFormat(vo.prem) }}원</p>
                </li>
              </ul>
            </li>
          </ul>
          <p class="tip_area">전자서명을 진행할 계약을 체크해주세요.</p>
          <div class="btn_area">
            <button type="button" class="btn_main" @click="confirm">
              <span>확인</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive, inject, computed } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import useDialog from "@/common/dialog";
import Header from "@/components/common/Header.vue";
import ActiveAnimation from "@/components/common/ActiveAnimation.vue";

export default {
  name: "mlpxCtrBasMttCnf",
  components: {
    Header,
    ActiveAnimation,
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const axios = inject("axios");
    const dialog = useDialog(inject("$vfm"));

    const state = reactive({
      currDate: util.formatDate(new Date(), "yyyymmdd"),
      rtrnAnimInsYn: false,
      yyyymmdd: util.formatDate(new Date(), "yyyy년 mm월 dd일"),
      ctrBasInfCoVoLst: [],
      polhdNm: "",
      inspeNm: "",
    });

    onMounted(async () => {
      await load();
      util.saveLog("009", "피보험자서명건선택화면"); // 009 : 화면진입

      if (sessionUserInfo == null) {
        router.push({ name: "sessionExpired" });
        return;
      }

      if (store.state.elcSgnInf.mblElcSgnEcusProgInfBcVo.length == 0) {
        dialog.alert("전자서명 대상 계약이 없습니다.").then(function () {
          router.push({ name: "athWyCho" });
          return;
        });
      } else {
        state.ctrBasInfCoVoLst = store.state.elcSgnInf.mblElcSgnEcusProgInfBcVo;
      }
    });

    const setAgrChk = function (idx) {
      // if (state.ctrBasInfCoVoLst[idx].complete == "서명완료") {
      //     state.ctrBasInfCoVoLst[idx].checkStatus = false;
      // 	dialog.alert("서명이 이미 완료된 계약입니다.")
      // 	return;
      // }

      for (var i = 0; i < state.ctrBasInfCoVoLst.length; i++) {
        if (idx == i) continue;
        state.ctrBasInfCoVoLst[i].checkStatus = false;
      }
    };

    const confirm = () => {
      let checkedCtr = _.find(state.ctrBasInfCoVoLst, (d) => d.checkStatus);
      if (util.isEmpty(checkedCtr) || util.isNull(checkedCtr)) {
        dialog.alert("전자서명을 진행할 가계약을 선택해주세요");
        return;
      }

      let athParam = store.state.elcSgnInf.athData;
      athParam.prctrNo = checkedCtr.prctrNo;
      athParam.ctnsKdCd = checkedCtr.ctnsKdCd;
      athParam.orgCd = checkedCtr.trtpeOrgCd;
      athParam.cusNo = checkedCtr.rcipeCusNo;
      athParam.pcsCtnsSndReqId = checkedCtr.ctnsSndReqId;

      axios.json("/registPrtblAthNo.do", athParam).then(function (result) {
        let param = {};
        param.prctrNo = checkedCtr.prctrNo;
        param.orgId = checkedCtr.trtpeOrgId;
        param.orgCd = checkedCtr.trtpeOrgCd;
        param.cusId = checkedCtr.rcipeCusId;
        param.cusNo = checkedCtr.rcipeCusNo;
        param.inqStdDt = state.currDate;
        param.inqEdDt = state.currDate;
        param.ctnsKdCd = checkedCtr.ctnsKdCd;
        param.mblPrtKey = checkedCtr.polhdLastOpmtKey;
        param.rcipeCnChId = checkedCtr.rcipeCnchId;

        axios.json("/inspe/sesnReStr.do", param).then(function (result) {
          router.push({ name: "ctrBasMttCnf" });
        });
      });
    };

    const refresh = () => {
      let cusMap = store.state.elcSgnInf.cusInfo;
      axios
        .json("/inspe/retrieveMblElcSgnEcusProgInf.do", {
          rcipeIdfNo: cusMap.bdtIdfNo,
          inqStdDt: state.currDate,
          inqCtnsKdCd: "120445",
          prctrInfInqYn: "1",
          sgnCompInclYn: "",
        })
        .then((res) => {
          if (res.data.mblElcSgnEcusProgInfBcVo.length == 0) {
            dialog.alert("전자서명 대상 계약이 없습니다.").then(function () {
              router.push({ name: "athWyCho" });
              return;
            });
          } else {
            state.ctrBasInfCoVoLst = res.data.mblElcSgnEcusProgInfBcVo;
            store.commit(
              "elcSgnInf/changeMblElcSgnEcusProgInfBcVo",
              res.data.mblElcSgnEcusProgInfBcVo
            );
          }
        });
    };

    return {
      state,
      setAgrChk,
      confirm,
      refresh,
    };
  },
  methods: {
    numberFormat(number) {
      if (!number) {
        return 0;
      } else {
        return util.addCommas(number + "");
      }
    },
  },
};
</script>

<style scoped>
.fr {
  float: right;
}
</style>
